import script from "./TheMainNavigation.vue?vue&type=script&lang=ts&setup=true"
export * from "./TheMainNavigation.vue?vue&type=script&lang=ts&setup=true"

import "./TheMainNavigation.vue?vue&type=style&index=0&id=32b3b87a&lang=css"

const __exports__ = script;

export default __exports__